<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
};
</script>

<style lang="scss">
@import './assets/scss/all';
body{
  font-family: -apple-system, BlinkMacSystemFont,
  "Segoe UI", "Microsoft JhengHei",
  Roboto, "Helvetica Neue", Arial, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue